import Vue                                    from 'vue'
import VueRouter                              from 'vue-router'
import Home                                   from '@/views/Home.vue'
import SigninPage                             from '@/views/signin/index.vue'
import Tasks                                  from '@/views/tasks/index.vue'
import BOM                                    from '@/views/bom/index.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks,
    beforeEnter (to, from, next) {
      //if (store.state.idToken) {
      if ( localStorage.getItem('token') ) {
        next()
      } else {
        next('/signin')
      }
    }
  },
  {
    path: '/bom/:taskid',
    name: 'BOM',
    component: BOM,
    // props function to cast taskid as number if loading from the url string
    props(route) {
      const props = { ...route.params }
      props.taskid = +props.taskid
      return props
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/signin',
    name: 'signin',
    component: SigninPage    
  },
  {
    path: '/', 
    redirect: '/signin'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
